/* eslint-disable react-hooks/exhaustive-deps */
//

/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { IconDotsVertical, IconMinus, IconPlus } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import ListView from "../../../components/common/ListView";
import ToggleButton from "../../../components/ToggleButton";
import { useForm } from "react-hook-form";
import {
  useFetchZoneData,
  useUpdateZoneData,
  useUpdateZoneStatus,
  useZoneCreateMutation,
} from "../../../apis/zoneAndTierApis";
import MessageModal from "../../../components/MessageModal";
import toast from "react-hot-toast";
import AddZoneModal from "./AddZoneModal";
import ViewCitiesModal from "./ViewCitiesModal";
import RoleToggle from "../../../components/RoleToggle";
import useDebounce from "../../../utilities/useDebounce";
import Pagination from "../../../components/common/Pagination";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";

type ZoneFormValues = {
  name: string;
  tireId: string | null;
  courierCompanyId: string | null;
  paymentMode: string;
  capacityPerDay: string | null;
  pricePerShipment?: string;
};

type Props = {
  options: string[];
  active: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
};

export default function ZoneListTab({ options, active, onChange }: Props) {
  const [searchFor, setSearchFor] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const {
    data: zoneData,
    refetch: zoneRefetch,
    isFetching,
    isLoading,
  } = useFetchZoneData(pageNo, limit, searchFor);
  const { mutate, isPending: activePending } = useZoneCreateMutation();
  const { mutate: updateZoneStatus, isPending: statusPending } =
    useUpdateZoneStatus();
  const { mutate: updateZoneData, isPending: zoneUpdatePending } =
    useUpdateZoneData();

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    zoneRefetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const [zoneItem, setZoneItem] = useState<any>(null);
  const [zoneDataArray, setZoneDataArray] = useState<any>(zoneData);
  const [citiesArray, setCitiesArray] = useState<any>();
  const [isViewCitiesOpen, setIsViewCitiesOpen] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [status, setStatus] = useState<string>("");

  const [isModalOpen, setIsModalOpen] = useState(false); // inline Add/Edit form toggle
  const [editStatus, setEditStatus] = useState(false); // false => Add, true =>

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    watch,
    formState: { errors },
    setValue,
    control,
  } = useForm<any>();

  useEffect(() => {
    if (zoneData) setZoneDataArray(zoneData);
  }, [zoneData]);

  const handleToggleModal = () => {
    // When clicked Plus/Minus
    setEditStatus(false);
    setZoneItem(null);
    setIsModalOpen((prev) => !prev);
    reset();
  };

  const handleEditData = (item: any) => {
    setEditStatus(true);
    setZoneItem(item);
    reset();
    setIsModalOpen(true); // open inline modal with edit data
  };

  const handleViewCities = (cities: any) => {
    setCitiesArray(cities);
    setIsViewCitiesOpen(true);
  };

  const handleToggleStatus = async (zone: any) => {
    setZoneItem(zone);
    setStatus(zone.status);
    setActionModal(true);
  };

  const handleUpdateStatus = async () => {
    const newStatus = zoneItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    const updatedZoneData = zoneDataArray.zones.map((v: any) =>
      v.id === zoneItem?.id ? { ...v, status: newStatus } : v
    );
    setZoneDataArray({ ...zoneDataArray, zones: updatedZoneData });
    await updateZoneStatus({ id: zoneItem?.id, status: newStatus });
    setActionModal(false);
    setZoneItem(null);
  };

  const handleAddZone = (data: any) => {
    mutate(
      { ...data },
      {
        onSuccess: () => {
          reset();
          zoneRefetch();
          setIsModalOpen(false);
          toast.success("Zone Added Successfully.");
        },
        onError: (error) => toast.error(`${error}`),
      }
    );
  };

  const handleUpdateZoneData = (data: any) => {
    updateZoneData(
      {
        id: zoneItem?.id,
        name: data?.name,
        capacityPerDay: data?.capacityPerDay,
        courierCompanyId: data?.courierCompanyId,
        paymentMode: data?.paymentMode,
        tireId: data?.tireId,
        pricePerShipment: data?.pricePerShipment,
      },
      {
        onSuccess: () => {
          reset();
          zoneRefetch();
          setIsModalOpen(false);
          setZoneItem(null);
          setEditStatus(false);
          toast.success("Zone Update Successfully.");
        },
        onError: (error) => toast.error(`${error}`),
      }
    );
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  return (
    <div>
      <div className="space-y-4">
        {/* LIST TABLE */}
        <div className="rounded-[20px]">
          <div className="flex items-start">
            <div className="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] flex items-center justify-between px-6 py-3 w-full rounded-tl-[20px] rounded-tr-[30px]">
              <RoleToggle
                options={options}
                active={active}
                onChange={onChange}
              />
              {/* <h1 className="text-lg font-medium text-[#212121]">Zone Lists</h1> */}
              <div className="flex gap-2">
                <NormalSearch
                  value={searchFor}
                  onChange={(e) => {
                    setSearchFor(e.target.value);
                    setPageNo(1);
                  }}
                />
                <button
                  type="button"
                  onClick={handleToggleModal}
                  className="bg-[#FBD037] text-[#212121] text-sm font-semibold p-2 rounded-full"
                >
                  {isModalOpen ? (
                    <IconMinus stroke={1.5} size={24} />
                  ) : (
                    <IconPlus stroke={1.5} size={24} />
                  )}
                </button>
              </div>
            </div>
          </div>
          {/* ADD/EDIT INLINE CARD */}

          {isModalOpen && (
            <div className=" p-4 border-t bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
              <h1 className="text-lg font-medium text-[#212121]">
                {editStatus ? "Edit Zone" : "Add Zone"}
              </h1>
              <AddZoneModal
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                clearErrors={clearErrors}
                control={control}
                reset={reset}
                zoneItem={zoneItem}
              />

              {/* Inline action buttons */}
              <div className=" ">
                <button
                  type="button"
                  onClick={() => {
                    editStatus
                      ? handleSubmit(handleUpdateZoneData)()
                      : handleSubmit(handleAddZone)();
                  }}
                  className="px-4 py-2 bg-[#FBD037] text-[#212121] font-medium rounded-full"
                  disabled={editStatus ? zoneUpdatePending : activePending}
                >
                  {editStatus
                    ? zoneUpdatePending
                      ? "Updating..."
                      : "Update"
                    : activePending
                    ? "Adding..."
                    : "Add Zone"}
                </button>
              </div>
            </div>
          )}
          {isLoading ? (
            <TableSkeleton
              mainClass="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
              subClassName=""
              columns={[
                "#",
                "Zone Name",
                "Warehouse",
                "Country",
                "Price",
                "Capacity",
                "Courier Company",
                "Payment Type",
                "For",
                "Priority",
                "Status",
              ]}
              rows={6}
            />
          ) : zoneDataArray?.zones?.length ? (
            <ListView
              tdClassName="rounded-r-none rounded-l-none"
              trClassName="hover:bg-[#FBD037]/20"
              mainDivClassName="rounded-b-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
              mailDivClassName="p-0 bg-transparent rounded-r-none rounded-br-3xl rounded-b-[20px]"
              thClassName="border-t"
              data={zoneDataArray?.zones ?? []}
              columns={[
                {
                  label: "#",
                  render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
                },
                { label: "Zone Name", render: (c: any) => c.name },
                { label: "Warehouse", render: (c: any) => c.warehouseName },
                { label: "Country", render: (c: any) => c.countryName },
                { label: "Price", render: (c: any) => c.pricePerShipment },
                { label: "Capacity", render: (c: any) => c.capacityPerDay },
                { label: "Courier Company", render: (c: any) => c.companyName },
                { label: "Payment Type", render: (c: any) => c.paymentMode },
                { label: "For", render: (c: any) => c.zonetype },
                { label: "Priority", render: (c: any) => c.priority },
                // { label: "Date", render: (c: any) => formatDate(c.createdAt) },
                {
                  label: "Status",
                  render: (c: any) => (
                    <div className="flex justify-center">
                      <ToggleButton
                        onChange={() => handleToggleStatus(c)}
                        checked={c.status === "ACTIVE"}
                      />
                    </div>
                  ),
                },
                {
                  label: "Actions",
                  render: (c: any) => (
                    <div className="relative flex justify-center">
                      <button
                        onClick={() =>
                          setOpenDropdownIndex(
                            openDropdownIndex === c ? null : c
                          )
                        }
                        className="p-2 border rounded-full bg-[#F7F6F2]"
                      >
                        <IconDotsVertical size={20} />
                      </button>

                      {openDropdownIndex === c && (
                        <div
                          ref={dropdownRef}
                          className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-12 w-28 -top-8 z-50 mt-2   rounded-xl shadow-lg overflow-hidden"
                        >
                          {/* <div className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer">
                          View Details
                        </div> */}
                          <div
                            onClick={() =>
                              handleViewCities(c.coverageCityNames)
                            }
                            className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                          >
                            View Cities
                          </div>
                          <div
                            onClick={() => handleEditData(c)}
                            className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                          >
                            Edit
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            <NoDataFound
              subClassName=""
              mainClassName="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-b-3xl"
            />
          )}

          {zoneDataArray?.totalPages > 1 && (
            <div className="flex justify-center items-center py-4">
              <Pagination
                currentPage={pageNo}
                totalPages={zoneDataArray?.totalPages}
                fetchData={handlePaginationFetch}
              />
            </div>
          )}
        </div>
      </div>

      {/* Confirm Activate/Deactivate */}
      <MessageModal
        open={actionModal}
        onClose={() => setActionModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={handleUpdateStatus}
        isPending={statusPending}
        size="md"
      />

      {/* Cities Modal */}
      <ViewCitiesModal
        citiesItem={citiesArray}
        open={isViewCitiesOpen}
        onClose={() => setIsViewCitiesOpen(false)}
      />
    </div>
  );
}
